export const Footer = ()=>{
    return(
        <>
            <footer>
                <div className="container">
                <div className="row">
                    <div className="col-lg-12 wow fadeIn" data-wow-duration="1s" data-wow-delay="0.25s">
                    <h6 className="text-center mb-5">© Copyright 2023 <span style={{color: "#FE3F40"}}>TAXEPAYE</span>. Tous droits réservés.</h6>
                    </div>
                </div>
                </div>
            </footer>
        </>
    )
}